import { createSetPropMutation } from '@/store/utils';
import * as types from '@/store/spFreelancerRegistration/mutationTypes';

export default {
  [types.REMOVE_SP_FREELANCER_REGISTRATION_DATA](state) {
    state.spFreelancerRegistrationCompanyIpAddressInfo = {};
    state.spFreelancerRegistrationCompanySocialNetworkLinkInfo = {};
    state.spFreelancerRegistrationCompanyRecommendationInfo = {};
    state.spFreelancerRegistrationCompanyCertificationInfo = {};
    state.spFreelancerServices = [];
    state.spFreelancerCertificates = [];
    state.spFreelancerClientAvatar = null;
    state.spFreelancerRegistrationEmailVerificationInfo = {};
    state.spFreelancerClientInfo = {};
    state.spFreelancerServicesInfo = {};
    state.spFreelancerRegistrationCurrentStep = 1;
    state.spFreelancerRegistrationVisitedStepsCnt = 1;
    state.spFreelancerRegistrationFilledStepsCnt = 0;
    state.spFreelancerLoading = {};
    state.spFreelancerLoadingErrors = {};
    state.spFreelancerRecaptchaToken = null;
    state.spFreelancerEmailVerificationSent = false;
    state.spFreelancerRegistrationForthStepValid = false;
  },
  [types.SET_SP_FREELANCER_REGISTRATION_FORTH_STEP_VALID]: createSetPropMutation('spFreelancerRegistrationForthStepValid'),
  [types.SET_SP_FREELANCER_RECOMMENDATION_INFO]: createSetPropMutation('spFreelancerRegistrationCompanyRecommendationInfo'),
  [types.SET_SP_FREELANCER_SOCIAL_NETWORK_LINK_INFO]: createSetPropMutation('spFreelancerRegistrationCompanySocialNetworkLinkInfo'),
  [types.SET_SP_FREELANCER_IP_ADDRESS_INFO]: createSetPropMutation('spFreelancerRegistrationCompanyIpAddressInfo'),
  [types.SET_SP_FREELANCER_COMPANY_CERTIFICATION]: createSetPropMutation('spFreelancerRegistrationCompanyCertificationInfo'),
  [types.SET_SP_FREELANCER_SERVICES_INFO]: createSetPropMutation('spFreelancerServicesInfo'),
  [types.SET_SP_FREELANCER_EMAIL_VERIFICATION_INFO]: createSetPropMutation('spFreelancerRegistrationEmailVerificationInfo'),
  [types.SET_SP_FREELANCER_CLIENT_REGISTRATION_DATA]: createSetPropMutation('spFreelancerClientInfo'),
  [types.SET_SP_FREELANCER_REGISTRATION_CURRENT_STEP]: createSetPropMutation('spFreelancerRegistrationCurrentStep'),
  [types.SET_SP_FREELANCER_REGISTRATION_FILLED_STEPS_COUNT]: createSetPropMutation('spFreelancerRegistrationFilledStepsCnt'),
  [types.SET_SP_FREELANCER_REGISTRATION_VISITED_STEPS_COUNT]: createSetPropMutation('spFreelancerRegistrationVisitedStepsCnt'),
  [types.SET_SERVICES]: createSetPropMutation('spFreelancerServices'),
  [types.SET_CERTIFICATES]: createSetPropMutation('spFreelancerCertificates'),
  [types.SET_SP_FREELANCER_CERTIFICATES_INFO_LOADING]: createSetPropMutation('spFreelancerLoading'),
  [types.SET_SP_FREELANCER_CERTIFICATES_INFO_LOADING_ERRORS]: createSetPropMutation('spFreelancerLoadingErrors'),
  [types.SET_SP_FREELANCER_SERVICES_INFO_LOADING]: createSetPropMutation('spFreelancerLoading'),
  [types.SET_SP_FREELANCER_SERVICES_INFO_LOADING_ERRORS]: createSetPropMutation('spFreelancerLoadingErrors'),
  [types.SET_SP_FREELANCER_CLIENT_AVATAR]: createSetPropMutation('spFreelancerClientAvatar'),
  [types.SET_SP_FREELANCER_REGISTRATION_RECAPTCHA_TOKEN]: createSetPropMutation('spFreelancerRecaptchaToken'),
  [types.SET_SP_FREELANCER_EMAIL_VERIFICATION_REQUESTED]: createSetPropMutation('spFreelancerEmailVerificationSent'),
};
